import * as React from "react"
import { Head, router } from "@inertiajs/react"
import { Avatar } from "@ui/Avatar"
import { Button } from "@ui/Button"
import { Card } from "@ui/Card"
import { Field } from "@ui/Field"
import { Input } from "@ui/Input"
import { useTheme, type ThemeMode } from "@components/ThemeContext"
import type { User } from "@lib/inertia-types"

export default function Profile({ user }: { user: User }) {
  const [name, setName] = React.useState(user.name ?? "")
  const { mode, setMode } = useTheme()

  return (
    <>
      <Head title="Profile · Fetch" />
      <div className="mx-auto max-w-2xl px-6 py-8">
        <h1 className="mb-6 text-title3 font-semibold text-cloverhound-gray-900 dark:text-cloverhound-gray-50">
          Profile
        </h1>

        <Card padding="lg" className="mb-6">
          <div className="mb-4 flex items-center gap-3">
            <Avatar size="xl" alt={name || user.email_address} src={user.avatar_url ?? undefined} />
            <div>
              <p className="text-small font-medium text-cloverhound-gray-900 dark:text-cloverhound-gray-50">
                {user.email_address}
              </p>
              <p className="text-mini text-cloverhound-gray-500">Signed in with Google</p>
            </div>
          </div>
          <Field label="Display name">
            <Input value={name} onChange={(e) => setName(e.target.value)} className="max-w-sm" />
          </Field>
          <div className="mt-4 flex justify-end">
            <Button onClick={() => router.patch("/settings/profile", { name })}>Save</Button>
          </div>
        </Card>

        <Card padding="lg">
          <h2 className="mb-3 text-small font-semibold text-cloverhound-gray-900 dark:text-cloverhound-gray-50">Theme</h2>
          <div className="flex gap-2">
            {(["light", "dark", "system"] as ThemeMode[]).map((m) => (
              <Button key={m} variant={mode === m ? "primary" : "secondary"} size="sm" onClick={() => setMode(m)}>
                {m[0].toUpperCase() + m.slice(1)}
              </Button>
            ))}
          </div>
        </Card>
      </div>
    </>
  )
}
